import moment from 'moment'
import store from '../../store'

export default function authentication ({ next, to }) {
  // check login logout, check session
  const storage = localStorage.getItem('remember') ? localStorage : sessionStorage
  const tokenExpired = JSON.parse(storage.getItem('tokenExpired'))
  const tokenExpiredRefresh = JSON.parse(storage.getItem('tokenExpiredRefresh'))
  if (storage.getItem('token')) {
    // check expired token
    if (tokenExpired && tokenExpired > (moment().valueOf())) {
      if (to.matched.some(record => record.name === 'Login')) {
        // redirect to dashboard
        next({ name: 'Dashboard' })
      }
      const userInfo = JSON.parse(storage.getItem('userInfo'))
      if (userInfo && !userInfo.password_changed && userInfo.configured) {
        if (to.matched.some(record => record.name !== 'ChangePassword')) {
          next({ name: 'ChangePassword', query: { alert: true } })
        }
      }
    } else {
      if (tokenExpiredRefresh && tokenExpiredRefresh > moment().valueOf()) {
        console.log('refresh token new')
      } else {
        let phoneNumberCti = ''
        let phoneNumberCtiHistory = ''
        let dateCtiHistory = ''
        if (to.matched.some(record => record.name !== 'Login')) {
          if (to.matched.some(record => record.name === 'Dial')) {
            phoneNumberCti = to.query.phoneCti ? to.query.phoneCti : ''
          }
          if (to.matched.some(record => record.name === 'Dashboard')) {
            phoneNumberCtiHistory = to.query.tel ? to.query.tel : ''
            dateCtiHistory = to.query.date ? to.query.date : ''
          }
          // redirect to Login
          if (phoneNumberCti) {
            next({ name: 'Login', params: { alert: true, phoneCti: phoneNumberCti } })
          } else if (phoneNumberCtiHistory && dateCtiHistory) {
            next({ name: 'Login', params: { alert: true, tel: phoneNumberCtiHistory, date: dateCtiHistory } })
          } else {
            store.dispatch('user/logout').then()
            next({ name: 'Login', params: { alert: true } })
          }
        }
      }
    }
  } else {
    let phoneNumberCti = ''
    let phoneNumberCtiHistory = ''
    let dateCtiHistory = ''
    if (to.matched.some(record => record.name !== 'Login')) {
      if (to.matched.some(record => record.name === 'Dial')) {
        phoneNumberCti = to.query.phoneCti ? to.query.phoneCti : ''
      }
      if (to.matched.some(record => record.name === 'Dashboard')) {
        phoneNumberCtiHistory = to.query.tel ? to.query.tel : ''
        dateCtiHistory = to.query.date ? to.query.date : ''
      }
      // redirect to Login
      if (phoneNumberCti) {
        next({ name: 'Login', params: { phoneCti: phoneNumberCti } })
      } else if (phoneNumberCtiHistory && dateCtiHistory) {
        next({ name: 'Login', params: { tel: phoneNumberCtiHistory, date: dateCtiHistory } })
      } else {
        store.dispatch('user/logout').then()
        next({ name: 'Login' })
      }
    }
  }
  return next()
}
